// Cookies page

import React from 'react'

function Cookies() {
  return (
    <div>
      This is cookies page.
    </div>
  )
}

export default Cookies
